export default () => {
    const form_checkbox_1 = <HTMLInputElement>document.getElementById('form1')
    const form_checkbox_2 = <HTMLInputElement>document.getElementById('form2')
    const form_1 = <HTMLDivElement>document.querySelector('.forms__form-1')
    const form_2 = <HTMLDivElement>document.querySelector('.forms__form-2')

    let params = new URLSearchParams(document.location.search);

    if (!form_checkbox_1 || !form_checkbox_2) {
        return
    }

    if (params.get("subject") === 'information') {
        form_checkbox_2.setAttribute('checked', 'checked')
        form_2.style.display = 'block';
        form_1.style.display = 'none';
    }

    form_checkbox_1.addEventListener('click', () => {
        form_1.style.display = 'block';
        form_2.style.display = 'none';
    });

    form_checkbox_2.addEventListener('click', () => {
        form_2.style.display = 'block'
        form_1.style.display = 'none';
    });
}